import { render, staticRenderFns } from "./BarLink.vue?vue&type=template&id=2c8d2367&scoped=true&"
import script from "./BarLink.vue?vue&type=script&lang=js&"
export * from "./BarLink.vue?vue&type=script&lang=js&"
import style0 from "./BarLink.vue?vue&type=style&index=0&id=2c8d2367&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d2367",
  null
  
)

export default component.exports